import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { Modal } from "./BottomSheetModal.tsx";
import { FloatInput } from "./FloatInput.tsx";
import { DropdownBox, DropdownBoxSearch } from "./DropdownBox.tsx";
import { AcceptanceRadio } from "./AcceptanceRadio.tsx";
import axiosInstance from "../axiosInstance.tsx";
import Toastify from "toastify-js";
import { toast } from "react-toastify";
import { SearchInput } from "./Input.tsx";
import { Input } from "./FullInviter.tsx";
import { useIsMobile } from "../App.tsx";
type UserModalProps = {
  isOpen: boolean;
  userId: string;
  onClose: () => void;
  selectedCountry: string;
  countries: string[];
  resourceAccess: boolean;
  onCountryChange: (country: string) => void;
  onBlock: () => void;
  onUnblock: () => void;
};

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const SectionHeader = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: var(--text-color);
`;

const SectionContent = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: var(--text-color);
  display: flex;
  gap: 12px;
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 8px;
  min-height: 40px;

`;

export const ActionButton = styled.button<{ variant?: "block" | "unblock" | "action", active?: boolean, payment?: boolean}>`
  flex: 1;
  padding: 10px 12px 10px 12px;
  font-size: 13px;
  font-weight: 500;
  font-family: 'Onest', sans-serif;
  border-radius: 6px;
  max-height: 40px;
         @media (max-width: 768px) {
    border-radius: 41px;
    
  }
  border: none;
  cursor: pointer;
  background-color: ${({variant}) => variant != "action"? "var(--primary-color)" : "#ACFF87" };
  color: ${({ variant, active, payment}) => active ? 
    variant === "block" ? (payment ? "var(--text-active-color)":"var(--text-error-color)") : "var(--text-success-color)" : "gray"};
  transition: 0.2s;
  &:hover {
    background-color: ${({variant}) => variant != "action"? "rgba(255, 255, 255, 0.05);" : "rgba(172, 255, 135, 0.8)" }; 
    transition: 0.2s;
  }
`;




export const CountryModal: React.FC<{
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  country: {
    name: string;
    price: number;
    enabled: boolean;
    blocked: boolean;
    for_sell: boolean;
  };
  onFlagChange?: (key: 'enabled' | 'blocked' | 'for_sell', value: boolean) => void;
  onPriceChange?: (value: number) => void;
}> = ({ isOpen, onClose, country, onFlagChange, onDelete, onPriceChange }) => {
  const [price, setPrice] = useState(country.price);
  const [acceptance, setAcceptance] = useState<"alwaysAccept" | "alwaysReject">(
    country.enabled ? "alwaysAccept" : "alwaysReject"
  );
  const [permission, setPermission] = useState<"allowed" | "blocked">(
    !country.blocked ? "allowed" : "blocked"
  );
  const [sale, setSale] = useState<"forSell" | "notForSell">(
    country.for_sell ? "forSell" : "notForSell"
  );

  useEffect(() => {
    setConfirmDelete(false)
  }, [isOpen])

  useEffect(() => {
    setPrice(country.price);
    setAcceptance(country.enabled ? "alwaysAccept" : "alwaysReject");
    setPermission(!country.blocked ? "allowed" : "blocked");
    setSale(country.for_sell ? "forSell" : "notForSell");
  }, [country]);

  const handleAcceptanceChange = (val: "alwaysAccept" | "alwaysReject") => {
    setAcceptance(val);
    onFlagChange?.('enabled', val === "alwaysAccept");
  };

  const handlePermissionChange = (val: "allowed" | "blocked") => {
    setPermission(val);
    onFlagChange?.('blocked', val === "blocked");
  };

  const handleSaleChange = (val: "forSell" | "notForSell") => {
    setSale(val);
    onFlagChange?.('for_sell', val === "forSell");
  };


  const handlePriceChange = (value: number) => {
    setPrice(value);
    onPriceChange?.(value);
  }

  const [confirmDelete, setConfirmDelete] = useState(false);
const timerRef = useRef<NodeJS.Timeout | null>(null);

const handleDeleteClick = () => {
  // если уже в режиме подтверждения — удаляем
  if (confirmDelete) {
    if (timerRef.current) clearTimeout(timerRef.current);
    onDelete(); // вызываем переданный callback
    return;
  }

  // включаем режим подтверждения
  setConfirmDelete(true);

  // откат обратно через 5 сек
  timerRef.current = setTimeout(() => {
    setConfirmDelete(false);
  }, 5000);
};


  return (
    <Modal isOpen={isOpen} onClose={onClose} header="Настройки страны" subHeader={`Для ${country.name}`}>
      
      <Section>
        <SectionHeader>Цена</SectionHeader>
        <SectionContent>
          <FloatInput
            before="$"
            value={price}
            onChange={handlePriceChange}
            step={0.05}
            min={0}
            max={20}
          />
        </SectionContent>
      </Section>

      <Section>
        <SectionHeader>Приёмка</SectionHeader>
        <SectionContent>
          <AcceptanceRadio
            value={acceptance}
            onChange={handleAcceptanceChange}
            options={[
              { value: "alwaysAccept", label: "Включена" },
              { value: "alwaysReject", label: "Выключена" },
            ]}
          />
        </SectionContent>
      </Section>

      <Section>
        <SectionHeader>Разрешение</SectionHeader>
        <SectionContent>
          <AcceptanceRadio
            value={permission}
            onChange={handlePermissionChange}
            options={[
              { value: "allowed", label: "Разрешено" },
              { value: "blocked", label: "Запрещено" },
            ]}
          />
        </SectionContent>
      </Section>

      <Section>
        <SectionHeader>Продажа</SectionHeader>
        <SectionContent>
          <AcceptanceRadio
            value={sale}
            onChange={handleSaleChange}
            options={[
              { value: "forSell", label: "Продавать" },
              { value: "notForSell", label: "Не продавать" },
            ]}
          />
        </SectionContent>
      </Section>

    <ActionButton
      variant="block"
      active={true}
      onClick={handleDeleteClick}
    >
      {confirmDelete ? "Точно удалить" : "Удалить"}
    </ActionButton>

    </Modal>
  );
};


export const UserModal: React.FC<UserModalProps> = ({
  isOpen,
  onClose,
  userId,
  selectedCountry,
  countries,
  resourceAccess,
  onResourceAccessChange,
  onCountryChange,
  onBlock,
  onUnblock,
}) => {


    const [stateLoading, setStateLoading] = useState(false);

    const updateUserState = async (newState: "blocked" | "accepted") => {
      setStateLoading(true);
      if (resourceAccess === (newState == "accepted")) {return;}
      try {
        const response = await axiosInstance.put("/userState", {
          id: userId,
          state: newState === "blocked" ? "blocked" : "accepted",
        });

        if (response.data.success) {
          onResourceAccessChange(newState === "accepted");
        } else {
          console.error("Не удалось обновить состояние пользователя");
        }
      } catch (err) {
        console.error("Ошибка запроса", err);
      } finally {
        setStateLoading(false);
      }
    };




    const [data, setData] = useState({})
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      setLoading(true);
      axiosInstance.get(`/userCountries?user_id=${userId}`).then((resp) => {setData(resp.data); setLoading(false)})

    }, [isOpen, userId])

  return (
    <Modal isOpen={isOpen} onClose={onClose} header="Информация о пользователе"
    subHeader={`Для пользователя: ${userId}`}>


        <DropdownBox options={Object.keys(data)} value={selectedCountry} onChange={onCountryChange}/>


      <Section>
        <SectionHeader>Индивидуальная цена</SectionHeader>
        <SectionContent><FloatInput before="$" value={data[selectedCountry]?.price || 0}           onChange={(v) => {axiosInstance.put("userCountry", {id: userId, country: selectedCountry, price: v, state: null}).then((resp) => {
          setData(prevData => ({
            ...prevData, // копируем все страны
            [selectedCountry]: {
              ...prevData[selectedCountry], // копируем объект конкретной страны
              price: v // обновляем только state
            }
          }));
          })}} step={0.05} min={0} max={20}/></SectionContent>
      </Section>

      <Section>
        <SectionHeader>Приёмка</SectionHeader>
        <SectionContent>
        <AcceptanceRadio
          value={data[selectedCountry]?.state || "default"}
          onChange={(v) => {axiosInstance.put("userCountry", {id: userId, country: selectedCountry, price: null, state: v}).then((resp) => {
          setData(prevData => ({
            ...prevData, // копируем все страны
            [selectedCountry]: {
              ...prevData[selectedCountry], // копируем объект конкретной страны
              state: v // обновляем только state
            }
          }));
          })}}
          options={[
            { value: "default", label: "По умолчанию" },
            { value: "alwaysAccept", label: "Всегда принимать" },
            { value: "alwaysReject", label: "Всегда отклонять" },
          ]}
        />
        </SectionContent>
      </Section>

      <Section>
        <SectionHeader>Доступ к ресурсу</SectionHeader>


                  <ButtonRow>
        <ActionButton variant="block" onClick={() => updateUserState("blocked")} active={resourceAccess}>
          Заблокировать
        </ActionButton>
        <ActionButton variant="unblock" onClick={() => updateUserState("accepted")} active={!resourceAccess}>
          Разблокировать
        </ActionButton>
      </ButtonRow>
  
      </Section>


    </Modal>
  );
};

type NewCountryModalProps = {
  isOpen: boolean;
  onClose: () => void;
  availableCountries: string[];
};

export const NewCountryModal: React.FC<NewCountryModalProps> = ({
  isOpen,
  onClose,
  availableCountries,
  onCountryCreated,
}) => {
  const [selectedCountry, setSelectedCountry] = useState<string | null>(null);
  const [price, setPrice] = useState(0.5);
  const [permission, setPermission] = useState<"allowed" | "blocked">("allowed");
  const [sale, setSale] = useState<"forSell" | "notForSell">("forSell");

  useEffect(() => {
    setSelectedCountry(null);
    setPrice(0.5);
    setPermission("allowed");
    setSale("forSell");
  }, [isOpen]);

  const handleAdd = async () => {
    if (!selectedCountry) return;

    try {
      const resp = await axiosInstance.post("/addCountry", {
        country: selectedCountry.split(" ")[0].trim(),
        price,
        blocked: permission === "blocked",
        for_sell: sale === "forSell",
      });
      if(!resp.data.success) {
        toast.error(resp.data.desc);
      }
      else{
        toast.success(resp.data.desc);
        onCountryCreated(resp.data.country)
      }
      
      onClose();
    } catch (err) {
      console.error(err);

    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} header="Добавить новую страну">

      <Section>
        <SectionHeader>Страна</SectionHeader>
        <SectionContent>
          <DropdownBoxSearch
            options={availableCountries}
            value={selectedCountry || ""}
            onChange={(val) => setSelectedCountry(val)}
          />
        </SectionContent>
      </Section>

      <Section>
        <SectionHeader>Цена</SectionHeader>
        <SectionContent>
          <FloatInput
            before="$"
            value={price}
            onChange={setPrice}
            step={0.05}
            min={0}
            max={20}
          />
        </SectionContent>
      </Section>

      <Section>
        <SectionHeader>Разрешение</SectionHeader>
        <SectionContent>
          <AcceptanceRadio
            value={permission}
            onChange={setPermission}
            options={[
              { value: "allowed", label: "Разрешено" },
              { value: "blocked", label: "Запрещено" },
            ]}
          />
        </SectionContent>
      </Section>

      <Section>
        <SectionHeader>Продажа</SectionHeader>
        <SectionContent>
          <AcceptanceRadio
            value={sale}
            onChange={setSale}
            options={[
              { value: "forSell", label: "Продавать" },
              { value: "notForSell", label: "Не продавать" },
            ]}
          />
        </SectionContent>
      </Section>

      <ActionButton active={true} variant="action" onClick={handleAdd}>Добавить</ActionButton>
    </Modal>
  );
};




type SimpleModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  showSearch?: boolean;
  placeholder?: string;
  text: string,
  size: "m" | "l",
  onSave: (value: string) => void;
};

export const TextModal: React.FC<SimpleModalProps> = ({
  isOpen,
  onClose,
  title,
  showSearch = false,
  placeholder = "Введите текст...",
  size = "m",
  text,
  onSave,
}) => {
  const [searchValue, setSearchValue] = useState("");
  const [textValue, setTextValue] = useState(text);
  const textareaRef = useRef<HTMLTextAreaElement>(null);

useEffect(() => {
  if (isOpen) {
    const timeout = setTimeout(() => {
      textareaRef.current?.focus();
    }, 0); // можно увеличить до 50мс, если нужно

    return () => clearTimeout(timeout);
  }
}, [isOpen]);


  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      setTextValue(text)
    }
    return () => {isMounted = false;}
  }, [text])

  useEffect(() => {
    if (isOpen) {
      setSearchValue("");
    }
  }, [isOpen]);

  // При изменении поиска перемещаем курсор к первому совпадению
  useEffect(() => {
    if (!textareaRef.current || !searchValue) return;

    const index = textValue.toLowerCase().indexOf(searchValue.toLowerCase());
    if (index >= 0) {
      textareaRef.current.setSelectionRange(index, index + searchValue.length);

      // Прокрутка к строке с найденным совпадением
      const lines = textValue.substr(0, index).split("\n").length;
      const lineHeight = 20; // примерная высота строки в px, подбери под свой стиль
      textareaRef.current.scrollTop = (lines - 1) * lineHeight;
    }
  }, [searchValue, textValue]);

  const handleSave = () => {
    onSave(textValue);
    onClose();
  };
  const isMobile = useIsMobile();
  return (
    <Modal isOpen={isOpen} onClose={onClose} header={title}>
      {showSearch && (
        <Section>
          <SectionContent>
            <SearchInput
              value={searchValue}
              extended={true}
              onChange={setSearchValue}
              placeholder="Поиск..."
            />
          </SectionContent>
        </Section>
      )}

      <Section style={{ display: "flex", flexDirection: "column" }}>
        <SectionContent style={{ flexGrow: 1 }}>
          <textarea
            ref={textareaRef}
            value={textValue}
            onChange={(e) => setTextValue(e.target.value)}
            placeholder={placeholder}
            style={{
              width: isMobile ? "100%" : size === "l" ? "75vw" : "100%",
              height: "35vh",
              borderRadius: 12,
              border: "1px solid #1F1F1F",
              background: "#0E0E10",
              color: "#fff",
              padding: "20px",
              resize: "none",
              fontSize: 14,
              fontFamily: "'Onest', sans-serif",
            }}
          />
        </SectionContent>
      </Section>

      <ActionButton active={true} variant="action" onClick={handleSave}>
        Сохранить
      </ActionButton>
    </Modal>
  );
};



export const StartInviteModal: React.FC = ({
  isOpen,
  onClose,
  categories,
  defaultValue,
  onRun,
}) => {

  const [count, setCount] = useState(defaultValue);
  const [category, setCategory] = useState(categories[0])

  useEffect(() => {
    if (isOpen) {
      setCount(defaultValue);
      setCategory(categories[0]);
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      setCount(0);
    }
  }, [category])

  const handleRun = () => {
      if(count == 0) {
        return;
      }
      onRun(count, category.title);
      onClose();
  }

    const handleCategory = (value) => {
      console.log(value, categories, value.split(" ")[0])
      setCategory(categories.find(x => x.title == value.split(" ")[0]));
    }

  return (
    <Modal isOpen={isOpen} onClose={onClose} header={"Запуск"}>
      <SectionHeader>Категория</SectionHeader>
      <Section>
        <SectionContent>
        <DropdownBox options={categories.map(c => `${c.title} (${c.count})`)} value={`${category.title} (${category.count})`} onChange={handleCategory}/>
        </SectionContent>
      </Section>

      <SectionHeader>Количество</SectionHeader>
      <Section>
        <SectionContent>
<Input
  type="number"
  value={count}          // <-- controlled
  style={{ width: "100%" }}
  onChange={(e) => setCount(Number(e.target.value))} // чтобы можно было печатать
  onBlur={(e) => {
    const num = Number(e.target.value);
    if (isNaN(num)) return;

    setCount(
      Math.min(Math.max(0, num), category.count)
    );
  }}
/>
        </SectionContent>
      </Section>


      <Section style={{marginTop: "auto"}}>
      <ActionButton active={true} variant="action" onClick={handleRun}>
        Запуск
      </ActionButton>
      </Section>
    </Modal>
  );
};
